module.exports = __webpack_public_path__ + "img/P150T_weapon_116.ee340f8f.png";